import React from 'react';

import { Alert } from 'react-bootstrap-5';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons';

export default function Warning() {
  return (
    <Alert className="d-flex align-items-center gap-2" variant="warning">
      <FontAwesomeIcon className="text-warning" icon={faExclamationTriangle} size="lg" />
      The royalty schedule has already been used for payments and some of the information cannot be edited.
    </Alert>
  );
}
